import { CategoryItem } from './CategoryItemModel';
import { Instance, types } from 'mobx-state-tree';

export const Category = types.model('Category', {
  _id: types.identifier,
  type: types.string,
  order: types.number,
  humanReadableId: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  subtitle: types.maybeNull(types.string),
  shortTitle: types.maybeNull(types.string),
  inDashboard: types.maybeNull(types.boolean),
  showCategoryItemsType: types.maybeNull(types.boolean),
  infoVisible: types.maybeNull(types.boolean),
  infoGenericPage: types.maybeNull(types.string),
  infoTitleGenericPage: types.maybeNull(types.string),
  numberItems: types.maybeNull(types.number),
  categoryItem: types.maybeNull(types.array(CategoryItem))
});

export type ICategoryModel = Instance<typeof Category>;
